import { css } from 'react-emotion';
import { getRgbaColor } from '../../utils/color';

export const styles = props => ({
  popup: css({
    backgroundColor: getRgbaColor(props.backdropColor, props.backdropOpacity),
    color: '#fff',
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'hidden',
    zIndex: props.zIndex,
    '& > div': {
      width: '100%',
      height: '100%'
    }
  }),
  close: css({
    position: 'absolute',
    top: 5,
    right: 5,
    zIndex: props.zIndex + 1,
    '& svg path': {
      fill: getRgbaColor(props.buttonColor),
      stroke: getRgbaColor(props.buttonIconColor),
      strokeWidth: '0.5px'
    }
  }),
  zoomWrap: css({
    width: '100%',
    height: '100%',
    '&, & > div': {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      margin: 'auto'
    },
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      width: 'auto',
      height: 'auto',
      zIndex: 0
    }
  })
});
